import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: {
    email: string;
    name: string;
  } | null;
  login: (token: string, user: { email: string; name: string }) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      token: null,
      user: null,
      login: (token: string, user: { email: string; name: string }) => {
        localStorage.setItem('authToken', token);
        set({
          isAuthenticated: true,
          token,
          user,
        });
      },
      logout: () => {
        localStorage.removeItem('authToken');
        set({
          isAuthenticated: false,
          token: null,
          user: null,
        });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
